import { render, staticRenderFns } from "./project_type_list.vue?vue&type=template&id=8d0868a4&scoped=true&"
import script from "./project_type_list.vue?vue&type=script&lang=js&"
export * from "./project_type_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0868a4",
  null
  
)

export default component.exports